import { useContext, useEffect, useRef, useState } from "react";
import { IonLoading, IonSelect, IonSelectOption } from "@ionic/react";
import { getUserSetupValues, saveUserValue } from "../api/UserSetups";
import { TranslationsContext } from "../util/Translations";
import { useSaveErrorToast } from "../pages/settings/settingsShared";

export interface QueryParams {
  getQueryList: () => void;
  queryList: string[];
  querySection: string;
  disabled?: boolean;
}

const DefaultWOQuery: React.FC<QueryParams> = (props) => {
  const { translations } = useContext(TranslationsContext);
  const { getQueryList, queryList, querySection, disabled } = props;
  const showSaveError = useSaveErrorToast();
  // last value confirmed by the server; used to skip echo events and to revert
  const savedQuery = useRef<string>("");
  const [currentQuery, setCurrentQuery] = useState<string>("");
  const [showLoading, setShowLoading] = useState(false);
  const [loadingDefault, setLoadingDefault] = useState(true);
  const startup = "startup query";

  const retrieveDefaultQuery = async () => {
    setShowLoading(true);
    setLoadingDefault(true);
    const data = {
      Section: querySection,
      ParameterList: [startup],
    };
    const response = await getUserSetupValues(data);
    if (
      response.data &&
      response.data[startup] &&
      response.data[startup].includes("--")
    ) {
      let query = response.data[startup].split("--");
      savedQuery.current = query[1];
      setCurrentQuery(query[1]);
    } else {
      savedQuery.current = response.data?.[startup] ?? "";
      setCurrentQuery(response.data?.[startup]);
    }
    setLoadingDefault(false);
    setShowLoading(false);
  };

  const changeDefaultQuery = async (query: string) => {
    setShowLoading(true);
    const data = {
      UserSection: querySection,
      UserParameter: startup,
      UserValue: query && query.includes("Public--") ? "Public--" + query : query,
    };
    const response = await saveUserValue(data).catch(() => undefined);
    setShowLoading(false);
    if (!response || response.isError) {
      setCurrentQuery(savedQuery.current);
      showSaveError();
      return;
    }
    savedQuery.current = query;
  };

  const handleQuerySelect = (queryName?: string) => {
    if (queryName && !loadingDefault && queryName !== savedQuery.current) {
      setCurrentQuery(queryName);
      changeDefaultQuery(queryName);
    }
  };

  useEffect(() => {
    setShowLoading(true);
    Promise.all([getQueryList(), retrieveDefaultQuery()]).finally(() => {
      setShowLoading(false);
    });
  }, []);

  return (
    <>
      <IonLoading
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
        duration={5000}
      />
      <IonSelect
        interface="alert"
        placeholder={translations["lbl_btn_select"] || "Select"}
        value={currentQuery}
        disabled={disabled}
        onIonChange={(ev) => {
          handleQuerySelect(ev.detail.value);
        }}
      >
        {queryList.map((qryName, index) => {
          return (
            <IonSelectOption key={`${index}-${qryName}`} value={qryName}>
              {qryName}
            </IonSelectOption>
          );
        })}
      </IonSelect>
    </>
  );
};
export default DefaultWOQuery;
